import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
//import ModelsView from "@/views/ModelsView.vue";
import HomeView from "@/views/HomeView.vue";
//import OnStockView from "@/views/OnStockView.vue";
import CustomView from "@/views/CustomView.vue";
import PricesView from "@/views/PricesView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    alias: "/",
    name: "home",
    component: HomeView,
  },
  // {
  //   path: "/whistles/models",
  //   name: "models",
  //   component: ModelsView,
  // },
  // {
  //   path: "/whistles/on-stock",
  //   name: "on-stock",
  //   component: OnStockView,
  // },
  {
    path: "/whistles/custom",
    name: "custom",
    component: CustomView,
  },
  {
    path: "/whistles/prices",
    name: "prices",
    component: PricesView,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
